import { useLoanApplication } from '@axo/shared/data-access/hooks';
import { DataAccessContext } from '@axo/shared/data-access/provider';
import { Product } from '@axo/shared/data-access/types';
import { Broker } from '@axo/shared/data-access/types/broker';
import { RoleName } from '@axo/shared/data-access/types/permissions';
import { MarketCountryCode } from '@axo/shared/types';
import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';

export interface ApplicationConditionalContext {
  broker?: Broker;
  marketCountry?: MarketCountryCode;
  productType?: Product;
  roles?: RoleName[];
}

export const useApplicationConditionalContext =
  (): ApplicationConditionalContext => {
    const { applicationID } = useParams();
    const { data: applicationData } = useLoanApplication(applicationID);
    const {
      state: {
        user: { roles },
      },
    } = useContext(DataAccessContext);

    return useMemo(
      () =>
        ({
          broker: applicationData?.Meta?.Broker,
          marketCountry: applicationData?.MarketCountry as
            | MarketCountryCode
            | undefined,
          productType: applicationData?.Product,
          roles: roles
            ?.filter((x) => x.Country === applicationData?.MarketCountry)
            .map((x) => x.Name as RoleName),
        }) satisfies ApplicationConditionalContext,
      [applicationData, roles],
    );
  };
